import dummy from "../assets/images/dummy.svg";
// import BBE from "../assets/images/feizy/BBE.jpeg";
// import TLRV from "../assets/images/feizy/TLRV.jpeg";
// import MLRLG from "../assets/images/feizy/MLRLG.jpeg";

export const configuratorData2 = {
  tokenUrl: "abfdc4a5-f8bb-3b60-9716-961c56970b31",
  id: 1,
  name: "Feizy",
};

export const profileData2 = [
  {
    id: 1,
    name: "Bedroom Bohemian Eclectic",
    thumb: dummy,
  },
  {
    id: 2,
    name: "Transitional LRVintage",
    thumb: dummy,
  },
  {
    id: 3,
    name: "Modern LRLuxury Glam",
    thumb: dummy,
  },
];

export const layoutData2 = [
  {
    id: 1,
    name: "Rug",
    thumb: dummy,
  },
];

export const sceneData2 = [
  {
    id: 5932,
    name: "Bedroom Bohemian Eclectic",
    profileId: 1,
    layoutId: 1,
    thumb: dummy,
  },
  {
    id: 5929,
    name: "Transitional LRVintage",
    profileId: 2,
    layoutId: 1,
    thumb: dummy,
  },
  {
    id: 5928,
    name: "Modern LRLuxury Glam",
    profileId: 3,
    layoutId: 1,
    thumb: dummy,
  },
];

export const imageHubSpotPosition2 = {
  'Rug': [
    {
      style: [
        { top: '77%', left: '50%' },
      ],
    },
  ],
};

export const imageData2 = [
  {
    sceneId: 421,
    labelId: 1723,
    min: 0,
    max: 1,
  },
  {
    sceneId: 423,
    labelId: 1725,
    min: 1,
    max: 2,
  },
  {
    sceneId: 424,
    labelId: 1786,
    min: 0,
    max: 1,
  },
  {
    sceneId: 755,
    labelId: 1791,
    min: 1,
    max: 2,
  },
];

export const redirectURL2 = [
  {
    url: "https://www.welspunliving.com/",
    name: "Nebula Reverie",
  },
  {
    url: "https://www.welspunliving.com/",
    name: "Celestial Cascade",
  },
  {
    url: "https://www.welspunliving.com/",
    name: "Fiona Patchwork",
  },
  {
    url: "https://www.welspunliving.com/",
    name: "Lunar Lattice",
  },
  {
    url: "https://www.welspunliving.com/",
    name: "Stardust Tapestry",
  },
  {
    url: "https://www.welspunliving.com/",
    name: "Eclipse Enigma",
  },
  {
    url: "https://www.welspunliving.com/",
    name: "Aurora Gleam",
  },
  {
    url: "https://www.welspunliving.com/",
    name: "Harlequin Reverse",
  },
  {
    url: "https://www.welspunliving.com/",
    name: "Floral Symphony",
  },
];
